import type { MultilinkStoryblok } from '@utils/storyblok/storyblok';
import type { SiteLinkData } from '@modules/site/types';

const EXTERNAL_PROTOCOLS = ['http://', 'https://', 'mailto:', 'tel:'];

export function resolveStoryblokLinkHref(
  link?: MultilinkStoryblok | SiteLinkData | null,
  fallback = '#',
): string {
  if (!link) {
    return fallback;
  }

  if ('email' in link && link.email) {
    return `mailto:${link.email}`;
  }

  const rawHref = ('cached_url' in link && link.cached_url) || ('url' in link && link.url) || '';

  if (rawHref.length === 0) {
    return fallback;
  }

  if (rawHref === 'home') {
    return '/';
  }

  if (
    rawHref.startsWith('#') ||
    EXTERNAL_PROTOCOLS.some((protocol) => rawHref.startsWith(protocol))
  ) {
    return rawHref;
  }

  const normalizedHref = rawHref.replace(/^\/?page(?:\/|$)/, '');

  if (normalizedHref.length === 0) {
    return '/';
  }

  return normalizedHref.startsWith('/') ? normalizedHref : `/${normalizedHref}`;
}

export function isExternalStoryblokLink(link?: MultilinkStoryblok | SiteLinkData | null): boolean {
  const href = resolveStoryblokLinkHref(link);
  return EXTERNAL_PROTOCOLS.some((protocol) => href.startsWith(protocol));
}
